<ng-template #modal let-modal>
  <div class="p-4">
    <div class="row header-background mx-0">
      <h6 class="col-12 px-0 mb-1">Report:</h6>
      <h4 class="header-title col-12 px-0">{{ assessmentName }}</h4>
    </div>

    <div class="row mx-0 mt-4 px-0">
      <p class="mb-0">Class Name</p>
    </div>

    <div class="row mx-0 mt-2 px-0">
      <div class="col-8 pl-0">
        <h1 class="my-0">{{ className }}</h1>
      </div>

      <div class="col-4 d-flex justify-content-end">
        <!-- share button -->
        <!-- print button -->
        <div class="d-flex justify-content-end">
          <div class="btn btn-primary px-4" (click)="requestAssessment()">
            Assign
          </div>
        </div>
      </div>
    </div>

    <!-- table -->
    <div class="row mx-0 mt-4 px-0">
      <p class="my-0 pl-0">Results</p>
    </div>

    <div class="mx-0 mt-2 p-2"
      [class.table-container]="studentAssessmentDetails && studentAssessmentDetails.length > 8">
      <div *ngIf="!studentAssessmentDetails || studentAssessmentDetails.length === 0" class="mt-5">
        <h2 class="font-italic">No results for this assessment</h2>
      </div>

      <div *ngIf="studentAssessmentDetails && studentAssessmentDetails.length > 0"
        [class.scrollTable]="studentAssessmentDetails && studentAssessmentDetails.length > 8" #assessmentsTable>
        <table class="table">
          <thead>
            <th>
              <app-sort-toggle columnName="StudentName" (orderChange)="updateSort($event)">
                Student Name
              </app-sort-toggle>
            </th>
            <th>
              <app-sort-toggle columnName="Status" (orderChange)="updateSort($event)">
                Status
              </app-sort-toggle>
            </th>
            <th>
              <app-sort-toggle columnName="NumAttempts" (orderChange)="updateSort($event)">
                # Attempts
              </app-sort-toggle>
            </th>
            <th>
              <app-sort-toggle columnName="LastAttempt" (orderChange)="updateSort($event)">
                Last Attempt
              </app-sort-toggle>
            </th>
            <th>
              <app-sort-toggle columnName="NumCorrect" (orderChange)="updateSort($event)"
                ngbTooltip="Number of correct answers given on most recent attempt"
                tooltipClass="custom-tooltip-styling">
                Correct
              </app-sort-toggle>
            </th>
            <th>
              <app-sort-toggle columnName="NumIncorrect" (orderChange)="updateSort($event)"
                ngbTooltip="Number of incorrect answers given on most recent attempt"
                tooltipClass="custom-tooltip-styling">
                Incorrect
              </app-sort-toggle>
            </th>
            <th></th>
          </thead>
          <tbody>
            <tr *ngFor="let studentAssessment of studentAssessmentDetails">
              <!-- (click)="goToAssignmentDetails($event, assignment)"> -->
              <td>{{ studentAssessment.StudentName }}</td>
              <td><i class="fas fa-star mr-2" [ngClass]="getStatusIconClass(studentAssessment)"></i>{{
                getStatus(studentAssessment) }}</td>
              <td>{{ studentAssessment.NumAttempts }}</td>
              <td>{{ getCompletedAt(studentAssessment) }}</td>
              <td>{{ getNumCorrectText(studentAssessment) }}</td>
              <td>{{ getNumIncorrectText(studentAssessment) }}</td>
              <td>
                <div class="d-flex justify-content-end">
                  <ng-template #assessmentDetailsTooltip>
                    <div class="results-tooltip p-2">
                      <div class="results-tooltip-title">Correct:</div>
                      <div>{{ getCorrectTargetsText(studentAssessment) }}</div>
                      <br>
                      <div class="results-tooltip-title">Incorrect:</div>
                      <div [ngClass]="getMissedTargetsClass(studentAssessment)">{{
                        getMissedTargetsText(studentAssessment) }}</div>
                    </div>
                  </ng-template>
                  <div class="view-details" [ngbTooltip]="assessmentDetailsTooltip" placement="end"
                    tooltipClass="custom-tooltip-styling">
                    View Details
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</ng-template>